import { AiAgentChatService } from '../services/ai-agent-chat.service';
import { AiAgentClientTool } from '../types/client-tool.type';

export const MAX_FOLLOWUPS = 4;
export const MAX_FOLLOWUP_LENGTH = 120;

/** Renders the model's suggested next questions as buttons under its answer. */
export const suggestFollowupsTool: AiAgentClientTool<{ prompts?: string[] }> = {
  name: 'suggest_followups',
  description:
    'Schlägt 2–3 kurze Anschlussfragen zur letzten Antwort vor. Höchstens einmal pro Antwort aufrufen.',
  silent: true,
  parameters: {
    type: 'object',
    properties: {
      prompts: {
        type: 'array',
        items: { type: 'string', maxLength: MAX_FOLLOWUP_LENGTH },
        maxItems: MAX_FOLLOWUPS,
        description: 'Kurze, eigenständig verständliche Folgefragen.',
      },
    },
    required: ['prompts'],
  },
  async execute(args, injector) {
    const prompts = (args?.prompts ?? [])
      .filter((p): p is string => typeof p === 'string' && p.trim().length > 0)
      .map((p) => p.trim().slice(0, MAX_FOLLOWUP_LENGTH))
      .slice(0, MAX_FOLLOWUPS);
    injector.get(AiAgentChatService).setFollowups(prompts);
    return { accepted: prompts.length };
  },
};
